import {FC} from "react";
import {CircularProgress} from "@mui/material";

const Loading: FC<LoadingProps> = ReactElement => {
    return (
        <div style={{"display":"flex"}}><CircularProgress/></div>
    )
}

type LoadingProps = {}

export default Loading
